'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _msg = require('./msg');

var _msg2 = _interopRequireDefault(_msg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _msg2.default; /**
                                  * Created by jf on 15/11/4.
                                  */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/msg/index.js
// module id = 1782
// module chunks = 7